module.exports = __webpack_public_path__ + "static/media/menu_icon_04.395fabd5.svg";